// extracted by mini-css-extract-plugin
export default {"ChatSessionListItem":"ChatSessionListItem-module-a4c64188c6a381b3f83e","avatar":"ChatSessionListItem-module-ddb597fa5cbb843a4126"};